
import TableList from "@components/templates/tablelist";
import compUpdate from "./update.vue";
import {
    HttpCarrierBillingAccountList,
} from "@/service/carrieraccount.js";
import { mapState, mapGetters } from "vuex";
import mixin from '../mixin';
export default {
    mixins: [TableList, mixin],
    components: {
        compUpdate,
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                }
            },
            Searchs: {
                show: true,
                labelWidth: 120,
            },
            Plugins: { show: true },
            initData: '',
        };
    },
    methods: {
        ajaxRequest: HttpCarrierBillingAccountList,
        exportQuery() {
            let searchData = {}
            Object.keys(this.formData.search).map(item => {
                searchData[`search[${item}]`] = this.formData.search[item]
            });
            this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/carrierBilling/batchExport", {
                ...searchData
            }, {
                executor: 'request',
                download: true,
            }).catch(err => {
                // this.$VMessage.error(err.message);
            })
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning(this.$t('global.common.selectdata', { defaultValue: '请选择至少一条数据' }));
            }
            switch (type) {
                case 'exportQuery':
                    this.exportQuery(params)
                    break
                case 'add':
                    this.operate = {
                        title: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'add',
                        showFooter: false
                    }
                    break;
                case 'query':
                    this.operate = {
                        title: this.$t('global.common.query', { defaultValue: '查看' }),
                        show: true,
                        width: 800,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'query',
                        showFooter: false
                    }
                    break;
                case 'edit':
                    this.operate = {
                        title: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                        show: true,
                        width: 600,
                        component: "compUpdate",
                        activeid: params,
                        querytype: 'edit',
                        showFooter: false
                    }
            }
        },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: this.$t('global.common.query', { defaultValue: '查看' }),
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: this.$t('global.common.operation_edit', { defaultValue: '编辑' }),
                    show: this.handleAuth('fbb.billing.edit'),
                    params: id,
                    operate: 'edit'
                }]
        },
    },
    computed: {
        ...mapGetters("dictionary", [
            "getCarrierAllList",
            "getBillcusWareList",
            "getUserManageWarehouseList",
            "getAlllogProCodeList",
            'getCustomServiceAllList',
        ]),
        ToolsData() {
            return [
                {
                    name: this.$t('erp.product.new_add', { defaultValue: '添加' }),
                    show: this.handleAuth('fbb.billing.add'),
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: this.$t('global.common.export', { defaultValue: '导出' }),
                    show: this.handleAuth('fbb.billing.export'),
                    operate: 'exportQuery',
                    theme: 'success'
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    key: 'IN_warehouseId',
                    show: true,
                    tag: 'Select',
                    options: this.getBillcusWareList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    }
                },
                {
                    label: this.$t('fbb.carrieraccount.carrier_group', { defaultValue: '物流产品' }),
                    tag: 'Select',
                    show: true,
                    key: 'IN_carrierGroupId',
                    // options: this.getAlllogProCodeList,
                    options: this.getCustomServiceAllList,
                    props: {
                        filterable: true,
                        clearable: true,
                        multiple: true
                    }
                },
                {
                    label: this.$t('fbb.carrieraccount.account_type', { defaultValue: '对接类型' }),
                    key: "EQ_accountType",
                    tag: "vSelect",
                    options: [
                        { value: 0, label: 'Post' },
                        { value: 1, label: 'Label' }
                    ],
                    show: true,
                },
                {
                    label: this.$t('fbb.carrieraccount.shipping_account', { defaultValue: 'Shipping账号' }),
                    tag: 'Input',
                    key: 'CN_shippingAccount'
                },
                {
                    label: this.$t('fbb.carrieraccount.billing_account', { defaultValue: 'Billing账号' }),
                    tag: 'Input',
                    key: 'CN_billingAccount'
                },
                {
                    label: this.$t('', { defaultValue: 'Label登录账户' }),
                    tag: 'Input',
                    key: 'CN_labelAccount'
                },
                {
                    label: 'Label Shipper Code',
                    tag: 'Input',
                    key: 'CN_labelShipperCode'
                }
            ]
        },
        columns() {
            return [
                {
                    title: this.$t('global.common.actions', { defaultValue: '操作' }),
                    width: 70,
                    render: this.getOperateNodes,
                }, {
                    title: this.$t('global.common.warehouse', { defaultValue: '仓库' }),
                    render: (h, { row }) => {
                        let warehouseItem = this.getBillcusWareList.filter(item => {
                            return item.value === row.warehouseId
                        })[0];
                        return <div>{warehouseItem ? warehouseItem.label : '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.carrieraccount.account_type', { defaultValue: '对接类型' }),
                    render: (h, { row }) => {
                        return <div>{row.accountType == 0 ? 'Post' : 'Label'}</div>
                    }
                },
                {
                    title: this.$t('fbb.carrieraccount.carrier_group', { defaultValue: '物流产品' }),
                    key: 'carrierGroupName',
                },
                {
                    title: this.$t('fbb.carrieraccount.shipping_account', { defaultValue: 'Shipping账号' }),
                    key: 'shippingAccount'
                },
                {
                    title: this.$t('fbb.carrieraccount.billing_account', { defaultValue: 'Billing账号' }),
                    key: 'billingAccount'
                },
                {
                    title: this.$t('', { defaultValue: 'Label登录账户' }),
                    key: 'labelAccount'
                },
                {
                    title: 'Label Shipper Code',
                    key: 'labelShipperCode'
                },
                {
                    title: this.$t('global.common.updatedAt', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    // width: 130
                }
            ];
        },

    }

};
